import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["contentId", "teamIds"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import { contentQueryKeys } from 'actions/content';
import api from 'utils/api';
export function getShareRecipientsCount(_x) {
  return _getShareRecipientsCount.apply(this, arguments);
}
function _getShareRecipientsCount() {
  _getShareRecipientsCount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(contentId) {
    var teamIds,
      filter,
      userCountQuery,
      _yield$api,
      items,
      total,
      _args2 = arguments;
    return _regeneratorRuntime.wrap(function (_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          teamIds = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : [];
          filter = {
            '-userSharing': {
              content_id: contentId
            }
          };
          if (teamIds.length > 0) {
            filter.userTeams = {
              team_id: teamIds
            };
          }
          userCountQuery = {
            fields: [{
              users_count: 'COUNT(DISTINCT id)'
            }],
            filter: filter,
            limit: 1
          };
          _context2.next = 1;
          return api('get', '/api/query/users', userCountQuery);
        case 1:
          _yield$api = _context2.sent;
          items = _yield$api.items;
          total = items[0].users_count;
          return _context2.abrupt("return", total > 0 ? total : 0);
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getShareRecipientsCount.apply(this, arguments);
}
function useFetchShareRecipientsCount(_ref) {
  var contentId = _ref.contentId,
    _ref$teamIds = _ref.teamIds,
    teamIds = _ref$teamIds === void 0 ? [] : _ref$teamIds,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function fetchPlaylistsAccessData() {
    return _fetchPlaylistsAccessData.apply(this, arguments);
  }
  function _fetchPlaylistsAccessData() {
    _fetchPlaylistsAccessData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", getShareRecipientsCount(contentId, teamIds));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchPlaylistsAccessData.apply(this, arguments);
  }
  var _useQuery = useQuery(_objectSpread(_objectSpread({
      queryKey: contentQueryKeys.contentAutoShareRecipientCount(contentId, teamIds),
      queryFn: fetchPlaylistsAccessData
    }, queryOptions), {}, {
      gcTime: 0
    })),
    _useQuery$data = _useQuery.data,
    data = _useQuery$data === void 0 ? 0 : _useQuery$data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  return _objectSpread({
    data: data
  }, result);
}
export default useFetchShareRecipientsCount;